/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Bag_CountInputs */

const en_orders_bag_count = /** @type {(inputs: Orders_Bag_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bag Count`)
};

const es_orders_bag_count = /** @type {(inputs: Orders_Bag_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteo de bolsas`)
};

/**
* | output |
* | --- |
* | "Bag Count" |
*
* @param {Orders_Bag_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_bag_count = /** @type {((inputs?: Orders_Bag_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Bag_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_bag_count(inputs)
	return es_orders_bag_count(inputs)
});